import { combineReducers } from 'redux';
import { textInputReducer } from './textInputReducer';
import { downloadAddinsReducer } from './downloadAddinsReducer';
import { taskPaneReducers } from '../../taskpane/reducers/rootReducer';
export const rootReducer = combineReducers({
	// MO
	webTextInput: textInputReducer,
	downloadAddins: downloadAddinsReducer,
	...taskPaneReducers,
});
